<template>
  <div class="orders">
    <p class="orders__title">{{ t('account.history.title') }}</p>
    <div class="orders__line"></div>
    <div class="orders__table">
<!--      <div class="orders__table-head">-->
<!--        <p>{{ t('account.history.type') }}</p>-->
<!--        <p>{{ t('account.history.amount') }}</p>-->
<!--        <p>{{ t('account.history.price') }}</p>-->
<!--        <p>{{ t('account.history.date') }}</p>-->
<!--      </div>-->
      <div class="orders__table-main">
        <div class="orders__table-item" v-for="order in deliveringOrders" :key="order.node.uuid" v-if="deliveringOrders.length && !isLoading">
          <div class="orders__table-item-head">
            <p>{{ t('orders.date') }}<span>{{ dayjs(order.node.buyTime).format('MM/D/YY HH:mm') }}</span></p>
          </div>
          <profile-orders-card
            v-for="product in order.node.orderProducts.edges"
            :key="product.node.product.uuid"
            :product="product.node"
          />
        </div>
        <div class="orders__table-item" v-for="order in orders" :key="order.node.uuid" v-if="orders?.length && !isLoading">
          <div class="orders__table-item-head">
            <p>{{ t('orders.date') }}<span>{{ dayjs(order.node.buyTime).format('MM/D/YY HH:mm') }}</span></p>
            <p>{{ t('orders.total') }}<span>{{ order.node.totalPrice }}€</span></p>
          </div>
          <profile-orders-card
            v-for="product in order.node.orderProducts.edges"
            :key="product.node.product.uuid"
            :product="product.node"
          />
        </div>
        <order-skeleton v-if="isLoading" />
        <p class="orders__empty" v-if="orders.length === 0 && deliveringOrders.length === 0 && !isLoading">{{ t('orders.noOrders') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, onMounted, onUnmounted, ref} from "vue";
import {Orders} from "@/core/api/orders.js";
import {useAuthStore} from "@/stores/auth.js";
import ProfileOrdersCard from "@/components/profile/profile-orders-card.vue";
import OrderSkeleton from "@/components/skeletons/order-skeleton.vue";
import dayjs from "dayjs";

const {t} = useI18n()
const authStore = useAuthStore()

const userEmail = computed(() => {
  return authStore.user ? authStore.user?.email : null
})
const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : null
})

const isLoading = ref(true)
const isDeliveringLoading = ref(false)
const orders = ref([])
const deliveringOrders = ref([])

const getOrders = async () => {
  isLoading.value = true

  const res = await Orders.getOrders("", accessToken.value, userEmail.value)
  orders.value = res.data.orders?.edges
      .filter((order) => order.node.status !== 'PENDING')
      .filter((order) => order.node.status !== 'DELIVERING')

  deliveringOrders.value = res.data.orders.edges
      .filter((order) => order.node.status === 'DELIVERING')

  isLoading.value = false
}

const getDeliveringOrders = async () => {
  isDeliveringLoading.value = true

  const res = await Orders.getOrders("DELIVERING", accessToken.value, userEmail.value)
  deliveringOrders.value = res.data.orders.edges

  if (deliveringOrders.value.length === 0) {
    await getOrders()
  }

  isDeliveringLoading.value = false
}

let a = setInterval(() => {});

onMounted( async () => {
  await getOrders()

  if (deliveringOrders.value.length > 0) {
    a = setInterval(async () => {
      await getDeliveringOrders()
    }, 30000)
  }
});

onUnmounted(() => {
  clearInterval(a);
});
</script>

<style lang="scss" scoped>
.orders {
  width: 100%;
  padding: 100px 45px;
  background-color: $white;
  min-height: 80vh;

  &__title {
    padding-left: 10px;
    color: #1E1E1E;
    font-family: Poppins, sans-serif;
    font-size: 32px;
    font-weight: 600;
  }

  &__line {
    margin-block: 10px;
    width: 100%;
    height: 2px;
    background-color: $black;
  }

  &__table {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 40px;

    &-head {
      padding: 0 40px 5px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid #D9DEE4;

      & p {
        color: $black;
        text-align: left;
        font-family: Nunito, sans-serif;
        font-size: 14px;
        font-weight: 600;

        &:first-child {
          width: 40%;
          text-align: center;
        }

        &:last-child {
          width: 20%;
          text-align: center;
        }
      }
    }

    &-main {
      display: flex;
      flex-direction: column;
      gap: 25px;
    }

    &-item {
      border: 1px solid $black;
      border-radius: 15px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      padding: 14px 19px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 15px;
      position: relative;

      &-head {
        display: flex;
        align-items: center;
        gap: 40px;
        padding-bottom: 10px;
        border-bottom: 1px solid $black;

        & p {
          font-family: Poppins, sans-serif;
          font-weight: 600;
          font-size: 18px;

          & span {
            font-weight: 500 !important;
            font-size: 16px !important;
          }
        }
      }

      &-status {
        position: absolute;
        top: 5px;
        right: 5px;

        width: 32px;
      }
    }
  }

  &__empty {
    text-align: center;
    font-family: Poppins, sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #393939;
  }
}

@media (max-width: 700px) {
  .orders {
    &__table {
      &-head {
        display: none;
      }
    }
  }
}
</style>